import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";
import _ from "lodash";

class AvailableSeasonsDataProvider extends BaseDataProvider {
  constructor(client) {
    super(client);
    this.cachedListResponse = {};
  }

  async getList(resource, params) {
    console.log(
      "AvailableSeasonsDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const sportCode =
      params.filter && params.filter.sportCode ? params.filter.sportCode : "";
    if (this.cachedListResponse[sportCode])
      return this.cachedListResponse[sportCode];
    const filterString = sportCode ? `(sportCode:"${sportCode}")` : "";
    const GET = gql`
          query {
            AvailableSeasons${filterString} {
              code
              label
              isCurrent
            }
          }`;
    try {
      const response = await this.client.query({ query: GET });
      const data = response.data.AvailableSeasons;
      for (let i = 0; i < data.length; i++) data[i].id = data[i].code;
      this.cachedListResponse[sportCode] = { data: data, total: data.length };
      return this.cachedListResponse[sportCode];
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }

  async getMany(resource, params) {
    console.log(
      "AvailableSeasonsDataProvider.getMany(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const list = await this.getList(resource, params);
    const data = params.ids.map((id) => _.find(list.data, (s) => s.id === id));
    return { data: data };
  }
}

export default AvailableSeasonsDataProvider;
